export const createSelectOptions = arr => arr.map(item => ({ label: item, value: item }));
